export default "__VITE_ASSET__C8MbqSw4__ 40w, __VITE_ASSET__3ecEYjjW__ 80w, __VITE_ASSET__BbBlVV2n__ 120w";